/**
 *  추천 기획전 페이지 이름
 */
export const RECOMMEND_EVENT_PAGE_NAME = {
  RECOMMEND_EVENT_LIST: '추천 기획전 리스트',
  RECOMMEND_EVENT_DETAIL: '추천 기획전 상세',
  RECOMMEND_EVENT_CREATE: '추천 기획전 등록',
  RECOMMEND_EVENT_COPY: '추천 기획전 복사',
};

/**
 *  추천 기획전 타입
 */
export const RECOMMEND_EVENT_TYPE = {
  /**
   *  검색 화면 - 추천 기획전
   */
  SEARCH_RECOMMEND: 0,
};

/**
 *  추천 기획전 타입 텍스트
 */
export const RECOMMEND_EVENT_TYPE_TEXT = {
  [RECOMMEND_EVENT_TYPE.SEARCH_RECOMMEND]: '검색 추천',
};

/**
 *  추천 기획전 타입 SELECT 리스트
 */
export const RECOMMEND_EVENT_TYPE_SELECT_LIST = [
  {
    id: RECOMMEND_EVENT_TYPE.SEARCH_RECOMMEND,
    name: RECOMMEND_EVENT_TYPE_TEXT[RECOMMEND_EVENT_TYPE.SEARCH_RECOMMEND],
  },
];

/**
 *  추천 기획전 메모 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_RECOMMEND_EVENT_MEMO = 2000;

/**
 *  추천 기획전 아이템 최소 개수
 */
export const MINIMUM_NUMBER_OF_RECOMMEND_EVENT_ITEM_COUNT = 3;

/**
 *  추천 기획전 아이템 최대 개수
 */
export const MAXIMUM_NUMBER_OF_RECOMMEND_EVENT_ITEM_COUNT = 5;
